<template>
      <div class="amount-div" v-if="tutorialVideosData">
        <div class="card-body depo-rgt-container mt-2">
            <div class="wallet-video-lang" v-for="(tut,index) in tutorialVideosData" :key="index">
                <div class="wallet-video-col" v-if="tut">
                    <h3>{{ $t(`how-to-${type == 2 ? 'deposit' : 'withdraw'}`, `How To ${type == 2 ? 'deposit' : 'withdraw'}`) }} 
                        ({{ index }})</h3>
                    <div class="embed-responsive">
                        <iframe width="100%" height="315" :src="tut" frameborder="0" allowfullscreen="allowfullscreen"> </iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'TutorialVideo',
    props:['type'],
    inject: ['walletConfig'],
     computed: {
        tutorialVideosData() {
            if(this.type == 2)
                return this.walletConfig?.deposit_video;
            else
                return this.walletConfig?.withdrawal_video;
        }
    },
}
</script>